import { AvailabilityCalendarSlot } from '../../../../../../../app/types/scheduling'
import styles from './styles.module.css'

interface ISlotProps {
  onClick: Function
  selectedAvailabilityCalendarSlot?: AvailabilityCalendarSlot
  availabilityCalendarSlot: AvailabilityCalendarSlot
}

export function Slot({
  onClick,
  selectedAvailabilityCalendarSlot,
  availabilityCalendarSlot,
}: ISlotProps) {
  if (!availabilityCalendarSlot) return null

  const { available, timeSlot } = availabilityCalendarSlot
  const { timeSlot: selectedTimeSlot } = selectedAvailabilityCalendarSlot || {}

  const {
    fromTime: slotFromTime,
    toTime: slotToTime,
    type: slotType,
  } = timeSlot

  let clickHandler = () => {
    // attach time slot details so that the backend can use it to make a timeSlot
    onClick(availabilityCalendarSlot)
  }

  let slotClassName = styles.slotCard
  let backgroundColor = 'var(--bg-primary)'

  if (!available) {
    clickHandler = () => {}
    slotClassName = `${styles.slotCard} ${styles.slotUnavailable}`
    backgroundColor = 'var(--slot-unavailable-bg)'
  }

  const isSlotSelected =
    selectedTimeSlot?.fromTime === slotFromTime &&
    // below prevents "anytime" and "morning" both appearing selected
    selectedTimeSlot?.type === slotType

  if (isSlotSelected) {
    backgroundColor = 'var(--selection-highlight)'
    slotClassName = styles.slotCard // Remove unavailable class if selected
  }

  // Only used for debugging
  // const { incomingPlannedRoutes } = timeSlot.routePlanning || {}
  // function getIncomingOrderTechnicianId() {
  //   let incomingTechnicianObjectId = ''

  //   Object.keys(incomingPlannedRoutes || {}).forEach((technicianId) => {
  //     if (incomingPlannedRoutes[technicianId].some((pathName) => pathName === 'incoming')) {
  //       incomingTechnicianObjectId = technicianId
  //     }
  //   })

  //   return incomingTechnicianObjectId
  // }

  function formatTime(time: Date | number) {
    return new Date(time).toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      timeZone: 'UTC',
    })
  }

  return (
    <div
      onClick={clickHandler}
      className={slotClassName}
      style={{ background: backgroundColor }}
    >
      <div className={styles.slotCardWindow}>{slotType}</div>
      <div className={styles.slotCardTimeRange}>
        {formatTime(slotFromTime || 0)} - {formatTime(slotToTime || 0)}
      </div>
      {/* <div className={styles.slotCardTimeRange}>{available ? getIncomingOrderTechnicianId() : ''}</div> */}
    </div>
  )
}
